import { render, staticRenderFns } from "./slideMenu.vue?vue&type=template&id=4f833585&scoped=true"
import script from "./slideMenu.vue?vue&type=script&lang=js"
export * from "./slideMenu.vue?vue&type=script&lang=js"
import style0 from "./slideMenu.vue?vue&type=style&index=0&id=4f833585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f833585",
  null
  
)

export default component.exports